const classNumbers = [
  ['1', 1],
  ['9', 9],
  ['14', 14],
  ['31', 31],
  ['36', 36],
  ['37', 37],
  ['39', 39],
  ['41', 41],
  ['42', 42],
  ['50', 50],
  ['51', 51],
  ['52', 52],
  ['53', 53],
  ['54', 54],
  ['56', 56],
  ['62', 62],
  ['65', 69],
  ['70', 70],
  ['71', 71],
  ['74', 74],
  ['76', 76],
  ['77', 77],
  ['78', 78],
  ['80', 80],
  ['82', 82],
  ['91', 91],
  ['92', 92],
  ['93', 93],
  ['94', 94],
  ['95', 95],
  ['96', 96],
  ['97', 97],
  ['100', 100],
  ['101', 101],
  ['102', 102],
  ['103', 103],
];

export default classNumbers;
